var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccountIconTfi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@0.5xicon/my_account/TFI blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-(with-icons)",
    transform: "translate(-1217.000000, -56.000000)",
    stroke: "#002C56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/my_account/TFI-blue",
    transform: "translate(1218.100000, 57.100000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.9,
    cy: 9.9,
    r: 10.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93030624,15.0833333 L14.8696938,15.0833333 C14.6231539,13.0640297 12.9025596,11.5 10.8166667,11.5 L8.98333333,11.5 C6.89744037,11.5 5.17684612,13.0640297 4.93030624,15.0833333 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.9,
    cy: 7.15,
    r: 2.75
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountIconTfi);
export default __webpack_public_path__ + "static/media/my_account_icon_tfi.7ca0c3d682f3aea008331e10d3b76b42.svg";
export { ForwardRef as ReactComponent };